import React from 'react';
import { graphql } from 'gatsby';
import Form from './form';
import CTA from './cta';
import Text from './text';
import Image from './image';
import Video from './video';
import List from './list';
import Header from './header';
import SharePage from './share-page';
import Static from './static';
import Buttons from './buttons';
import IconicText from './iconic-text';
import Highlights from './highlights';
import LatestBlogs from './latest-blogs';
import LatestPodcasts from './latest-podcasts';
import Download from './download';
import Quote from './quote';
import TextImage from './text-image';
import Logos from './logos';
import Popup from './popup';
import Products from './products';
import ShopItem from './shop-item';

export const pageQuery = graphql`
  fragment RowOptions on PdvRowOptions {
    id
    backgroundColor
    hideBottomSpacing
    hideTopSpacing
    hideRow
    sectionId
  }
  fragment Button on PdvButton {
    id
    link
    text
    variant
  }

  fragment Blocks on StrapiPagesPagesZone {
    typename: __typename

    ...on StrapiPagesPagesZoneBlocksButtons {
      id
      items {
        ...Button
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksDownload {
      id
      text: childStrapiPagesPagesZoneBlocksDownloadText {
        childMarkdownRemark {
          html
        }
      }
      button {
        ...Button
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksForm {
      id
      title
      subtitle
      thanxPage
      thanxMessageTitle
      thanxMessageSubTitle
      thanxMessageFooterText
      card
      strapiFormForm {
        ...StrapiForm
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksHeader {
      id
      title
      text: childStrapiPagesPagesZoneBlocksHeaderText {
        childMarkdownRemark {
          html
        }
      }
      fullWidth
      backgroundImage: image {
        url
        height
        width
        name
        localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
              breakpoints: [576, 768, 992, 1200, 2400]
              transformOptions: {
                cropFocus: CENTER
              }
            )
          }
        }
      }
      image {
        url
        height
        width
        name
        localFile {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              width: 1200
              height: 586
              breakpoints: [576, 768, 992, 1200, 2400]
              quality: 100
              transformOptions: {
                cropFocus: CENTER
              }
            )
          }
        }
      }
      button {
        ...Button
      }
      formId
      strapiFormForm {
        ...StrapiForm
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksHighlightCtaSection {
      id
      htmlTitle: childStrapiPagesPagesZoneBlocksHighlightCtaSectionTitle {
        childMarkdownRemark {
          html
        }
      }
      date
      buttonLink # @TODO: create ...Button
      buttonText
    }
    ...on StrapiPagesPagesZoneBlocksHighlights {
      id
      title
      highlights {
        id
        image {
          url
          height
          width
          name
          localFile {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                height: 380
                quality: 90
              )
            }
          }
        }
        title
        text
        button {
          ...Button
        }
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksIconicText {
      id
      items {
        id
        image {
          url
          height
          width
          name
          localFile {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                height: 140
                quality: 90
              )
            }
          }
        }
        title
        text
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksImage {
      id
      alt
      maxWidthInPx
      image {
        url
        height
        width
        name
        localFile {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              width: 800
              quality: 90
            )
          }
        }
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksLatestBlogs {
      id
      title
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksLatestPodcasts {
      id
      title
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksList {
      id
      title
      variant
      items {
        id
        title
        subtitle
        link
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksLogos {
      id
      items {
        id
        logo: image {
          url
          height
          width
          name
          localFile {
            childImageSharp {
              gatsbyImageData(
                quality: 80
                width: 300
                height: 200
                transformOptions: {
                  cropFocus: CENTER
                  fit: CONTAIN
                },
              )
            }
          }
        }
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksPopup {
      id
      text: childStrapiPagesPagesZoneBlocksPopupText {
        childMarkdownRemark {
          html
        }
      }
      openAfterSeconds
      thanxPage
      thanxMessageTitle
      thanxMessageSubTitle
      thanxMessageFooterText
      formId
      strapiFormForm {
        ...StrapiForm
      }
    }
    ...on StrapiPagesPagesZoneBlocksProducts {
      id
      category
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksQuote {
      id
      text: childStrapiPagesPagesZoneBlocksQuoteText {
        childMarkdownRemark {
          html
        }
      }
      author
      description
      image {
        url
        height
        width
        name
        localFile {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              quality: 80
              width: 576
            )
          }
        }
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksSharePage {
      id
      title
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksShopItem {
      id
      productId
      CTAbuttonText
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksStatic {
      id
      component: static
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksText {
      id
      text: childStrapiPagesPagesZoneBlocksTextText {
        childMarkdownRemark {
          html
        }
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksTextImage {
      id
      template
      text: childStrapiPagesPagesZoneBlocksTextImageText {
        childMarkdownRemark {
          html
        }
      }
      columnLayout
      smallImageSize
      button {
        ...Button
      }
      image {
        url
        height
        width
        name
        localFile {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              width: 768
              quality: 90
            )
          }
        }
      }
      smallImage: image {
        url
        height
        width
        name
        localFile {
          childImageSharp {
            gatsbyImageData(
              layout: FIXED
              width: 320
              quality: 90
            )
          }
        }
      }
      rowOptions {
        ...RowOptions
      }
    }
    ...on StrapiPagesPagesZoneBlocksVideo {
      id
      url
      title
      rowOptions {
        ...RowOptions
      }
    }
  }
`;

const Blocks = ({
  blocks,
  products,
  meta,
}) => (
  <>
    {blocks.map((block) => {
      switch (block.typename) {
        case 'StrapiPagesPagesZoneBlocksButtons':
          return <Buttons key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksDownload':
          return <Download key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksForm':
          return (
            <Form
              key={block.id}
              {...block}
            />
          );
        case 'StrapiPagesPagesZoneBlocksHeader':
          return <Header key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksHighlightCtaSection':
          return <CTA key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksHighlights':
          return <Highlights key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksIconicText':
          return <IconicText key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksImage':
          return <Image key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksLatestBlogs':
          return <LatestBlogs key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksLatestPodcasts':
          return <LatestPodcasts key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksList':
          return <List key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksLogos':
          return <Logos key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksPopup':
          return (
            <Popup
              key={block.id}
              {...block}
            />
          );
        case 'StrapiPagesPagesZoneBlocksProducts':
          return <Products key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksQuote':
          return <Quote key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksSharePage':
          return <SharePage pageTitle={meta.pageTitle} key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksShopItem':
          return (
            <ShopItem
              key={block.id}
              {...block}
              product={products?.nodes.find(
                ({ databaseId }) => databaseId === Number(block.productId),
              )}
            />
          );
        case 'StrapiPagesPagesZoneBlocksStatic':
          return <Static key={block.id} {...block} component={block.component} />;
        case 'StrapiPagesPagesZoneBlocksText':
          return <Text key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksTextImage':
          return <TextImage key={block.id} {...block} />;
        case 'StrapiPagesPagesZoneBlocksVideo':
          return <Video key={block.id} {...block} />;
        default: {
          console.warn('Unknown block', block.typename);
          return (
            <div />
          );
        }
      }
    })}
  </>
);

export default Blocks;
